angular.module("avant.filters").filter "LocalePhoneNumber", ->
  (input, locale) ->
    switch locale
      when "en-GB"
        country = "GB"
        number_limit = 11
      else
        country = "US"
        number_limit = 10
    phone = formatLocal(country, input)
    ## BELOW THESE LINES ONLY HERE TO LIMIT NUMBER OF CHARS..UNTESTED (comment out in between lines if bugs)
    numbers = phone and phone.replace(/\D/g, '').length
    difference = (numbers && (phone.length - numbers)) || 0
    cutoff = number_limit + difference
    if numbers and numbers > cutoff
      phone = phone.slice(0, cutoff)
    ## ABOVE THESE LINES ONLY HERE TO LIMIT NUMBER OF CHARS..UNTESTED (comment out in between lines if bugs)
    phone